export default __webpack_public_path__ + "static/media/logo-metacritic.90adc750.svg";